import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { postPAJAK010, postResumeActivatePackage } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import ResumeTicketActions from '../../../shared/components/ResumeTicketActions';
import SearchDateRange from '../../../shared/components/SearchDateRange';
import SideNav from '../../../shared/components/SideNav';
import TicketPurchase from '../../../shared/components/popup/TicketPurchase';
import { formatNumberWithCommas } from '../../../utils';

const RECEIPT_URL = 'https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp';

const TAB_LIST = [
    { label: '전체', key: 'totalCount', value: 'A' },
    { label: '사용', key: 'usedCount', value: 'USED' },
    { label: '미사용', key: 'unusedCount', value: 'UNUSED' },
    { label: '기간만료', key: 'expiredCount', value: 'E' },
];

const PAJAK010 = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [target, setTarget] = useState('A');
    const [statistic, setStatistic] = useState({});
    const [countTab, setCountTab] = useState({});
    const [listTicket, setListTicket] = useState([]);
    const [dataStartDate, setDataStartDate] = useState('');
    const [dataEndDate, setDataEndDate] = useState('');
    const [isTicketPurchasePopupOpen, setIsTicketPurchasePopupOpen] = useState(false);
    const [purchaseProductId, setPurchaseProductId] = useState('ticket-10');

    const handleOpenTicketPurchase = (productId) => {
        setPurchaseProductId(productId || 'ticket-10');
        setIsTicketPurchasePopupOpen(true);
    };

    const getListData = (startDate, endDate) => {
        const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postPAJAK010({
            page,
            target,
            startDate: startDateFormat,
            endDate: endDateFormat,
        })
            .then(({ data }) => {
                setStatistic(data?.data?.statistic || {});
                setCountTab(data?.data?.countTab || {});
                setListTicket(Array.isArray(data?.data?.list) ? data.data.list : []);
                setPages(data?.info || {});
            })
            .catch((error) => console.log(error));
    };

    const handleSearchDateRange = (startDate, endDate) => {
        setDataStartDate(startDate);
        setDataEndDate(endDate);
        getListData(startDate, endDate);
    };

    const handleTab = (e, value) => {
        e.preventDefault();
        if (value === target) return;
        setTarget(value);
        setSearchParams({ page: 1 });
    };

    useEffect(() => {
        getListData(dataStartDate, dataEndDate);
        // eslint-disable-next-line
    }, [page, target]);

    const handleOpenReceipt = (e, receiptNo) => {
        e.preventDefault();
        window.open(
            `${RECEIPT_URL}?noTid=${receiptNo}&noMethod=1`,
            '_blank',
            'width=430,height=700',
        );
    };

    const getPeriodDays = (item) => {
        const fromName = String(item?.goodName || '').match(/(\d+)\s*일/);
        if (fromName) return fromName[1];
        const fromCode = String(item?.productCode || '').match(/(\d+)/);
        return fromCode ? fromCode[1] : '';
    };

    const handleUsePeriodTicket = (item) => {
        const days = getPeriodDays(item);
        const message = days
            ? `현 시점부터 이력서 자유 열람을 시작하시겠습니까?\n한번 사용을 시작하시면 기간 중지와 환불이 불가합니다.\n기간: ${days}일`
            : '현 시점부터 이력서 자유 열람을 시작하시겠습니까?\n한번 사용을 시작하시면 기간 중지와 환불이 불가합니다.';
        if (!window.confirm(message)) return;

        postResumeActivatePackage(item?.orderNo)
            .then(({ data }) => {
                const result = typeof data === 'string' ? data : data?.data || data?.result;
                if (result === 'SUCCESS') {
                    window.alert('이력서 자유 열람이 시작되었습니다.');
                    getListData(dataStartDate, dataEndDate);
                } else {
                    window.alert(data?.message || '열람권 사용에 실패했습니다.');
                }
            })
            .catch((error) => console.log(error));
    };

    const renderStatus = (item) => {
        if (item?.statusType === 'ACTION_USE') {
            const isExpired = moment(item?.expiryDate, 'YYYY.MM.DD').isBefore(moment(), 'day');
            if (isExpired) {
                return <span className="cv-payment-list__status">기간완료</span>;
            }
            return (
                <span
                    className="cv-payment-list__status cv-payment-list__status--red"
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => handleUsePeriodTicket(item)}
                >
                    사용하기
                </span>
            );
        }

        if (item?.statusType === 'COUNT') {
            const count = Number(item?.displayStatus) || 0;
            if (count > 0) {
                return <span className="cv-payment-list__status cv-payment-list__status--blue">{item?.displayStatus}</span>;
            }
            return <span className="cv-payment-list__status">사용완료</span>;
        }

        return <span className="cv-payment-list__status">{item?.displayStatus}</span>;
    };

    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="info-list__cv" style={{ width: '100%' }}>
                        <h3 className="list__cv__tit">열람권 관리/영수증</h3>
                        <div className="cv-payment-list">
                            <div className="resume-ticket-summary">
                                <div className="resume-ticket-summary__status">
                                    <div className="resume-ticket-summary__panel resume-ticket-summary__panel--blue">
                                        <strong>이력서 일반 열람권</strong>
                                        <span>보유현황</span>
                                        <em>{statistic?.remainingAccessCount || 0}개</em>
                                    </div>
                                    <div className="resume-ticket-summary__panel resume-ticket-summary__panel--red">
                                        <strong>이력서 자유 열람권</strong>
                                        <span>열람 가능 시간</span>
                                        <em className="resume-ticket-summary__unused">
                                            {statistic?.periodAccessStatus || '미사용'}
                                        </em>
                                    </div>
                                </div>
                            </div>
                            <SearchDateRange
                                className="cv-payment-list__search"
                                handleSearchDateRange={handleSearchDateRange}
                                setSearchParams={setSearchParams}
                            />
                            <ResumeTicketActions onPurchaseClick={handleOpenTicketPurchase} />
                            <div className="mtch">
                                <div className="mtch__block mtch__block--rp4">
                                    {TAB_LIST.map((tab) => (
                                        <Link
                                            to="#"
                                            key={tab.value}
                                            className={`mtch__cnd ${target === tab.value ? 'active' : ''}`}
                                            onClick={(e) => handleTab(e, tab.value)}
                                        >
                                            {tab.label}({countTab?.[tab.key] || 0})
                                        </Link>
                                    ))}
                                </div>
                            </div>
                            <table className="cv-payment-list__table">
                                <thead>
                                    <tr>
                                        <th>구매일</th>
                                        <th>상품명</th>
                                        <th>만료 예정일</th>
                                        <th>결제금액</th>
                                        <th>잔여수량/사용</th>
                                        <th>영수증</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listTicket && listTicket.length > 0 ? (
                                        listTicket.map((item, index) => (
                                            <tr key={`cv-payment-${item?.walletId || index}`}>
                                                <td>{item?.purchaseDate}</td>
                                                <td>{item?.goodName}</td>
                                                <td>
                                                    <strong>{item?.expiryDate}</strong>
                                                </td>
                                                <td>{formatNumberWithCommas(item?.price)}원</td>
                                                <td>{renderStatus(item)}</td>
                                                <td>
                                                    <a
                                                        href={`${RECEIPT_URL}?noTid=${item?.receiptNo}&noMethod=1`}
                                                        className="cv-payment-list__receipt"
                                                        onClick={(e) => handleOpenReceipt(e, item?.receiptNo)}
                                                    >
                                                        <span>[영수증출력]</span>
                                                    </a>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={6}>데이터없습니다</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
            {isTicketPurchasePopupOpen && (
                <TicketPurchase
                    onClose={() => setIsTicketPurchasePopupOpen(false)}
                    defaultProductId={purchaseProductId}
                />
            )}
        </div>
    );
};

export default PAJAK010;
